(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip/assets/javascripts/views/parts/rows-display-view.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip/assets/javascripts/views/parts/rows-display-view.js');
"use strict";

const {
  useContext
} = React;
const {
  BetslipContext
} = svs.components.tipsen.betslip;
const {
  ReactIcon
} = svs.ui;
const {
  format
} = svs.utils;
const RowsDisplayView = _ref => {
  let {
    isExternalMSYS = false,
    isReduced = false,
    numRows,
    numberOfRows,
    selectedSystemSize
  } = _ref;
  const {
    isExtraSmall
  } = useContext(BetslipContext);
  const systemSize = isReduced ? selectedSystemSize : 0;
  const ariaLabel = systemSize > 0 ? "".concat(numRows, " rader av ").concat(systemSize) : "".concat(numRows, " rader");
  numberOfRows = format.Currency(numberOfRows);
  if (isExtraSmall) {
    return React.createElement("div", {
      className: "betslip-rows"
    }, isExternalMSYS ? React.createElement("span", {
      className: "f-400"
    }, "M-System: ") : React.createElement("span", {
      className: "f-400"
    }, "Rader: "), React.createElement("span", {
      className: "f-400"
    }, React.createElement("span", {
      className: "f-bold"
    }, numberOfRows), !isReduced && React.createElement("span", null, " st")), systemSize > 0 && React.createElement("span", {
      className: "f-400"
    }, ' ', "av", ' ', systemSize));
  }
  return React.createElement("div", {
    "aria-label": ariaLabel,
    className: "betslip-rows"
  }, React.createElement(ReactIcon, {
    color: "white",
    icon: "rows-three"
  }), isExternalMSYS ? React.createElement("span", {
    className: "f-600 betslip-row-title"
  }, "M-System: ") : React.createElement("span", {
    className: "f-600 betslip-row-title"
  }, "Rader: "), React.createElement("span", {
    className: "f-600 betslip-row-value"
  }, React.createElement("span", null, React.createElement("span", {
    className: "f-bold"
  }, numberOfRows), !isReduced && React.createElement("span", null, " st")), systemSize > 0 && React.createElement("span", {
    className: "f-600"
  }, ' ', "av", ' ', systemSize)));
};
setGlobal('svs.components.tipsen.betslip.views.parts.RowsDisplayView', RowsDisplayView);

 })(window);